import { z } from 'zod';
import { GetFlowRunBlockResponseSchema, GetFlowRunResponseSchema } from './response.js';
import { FlowRunSignalResponseSchema } from './signal.js';
const TAGS = ['FlowRun'];
export const FlowRunSignalGetRoute = {
    method: 'get',
    fullPath: '/flow-runs/signals/:signalId',
    summary: 'Get a flow run signal',
    description: 'Returns one signal for a flow run the caller can access, including its workflow and block identifiers, status, and response payload. Use this when the signal id is already known.',
    tags: TAGS,
    params: z.strictObject({ signalId: z.uuid() }),
    response: FlowRunSignalResponseSchema,
};
export const FlowRunGetRoute = {
    method: 'get',
    fullPath: '/flow-runs/explore/runs/:flowRunId',
    summary: 'Get a flow run',
    description: 'Returns one flow run the caller can access, including runtime metadata and block execution shells. Block output payloads are omitted; retrieve one block separately when its payload is needed.',
    tags: TAGS,
    params: z.strictObject({ flowRunId: z.uuid() }),
    response: GetFlowRunResponseSchema,
};
export const FlowRunBlockGetRoute = {
    capabilityTags: ['ResponseCouldIncludePhi'],
    method: 'get',
    fullPath: '/flow-runs/explore/runs/:flowRunId/blocks/:blockId',
    summary: 'Get a flow run block',
    description: 'Returns one block execution from a flow run the caller can access, including that block’s complete output payload, metadata, status, and timing.',
    tags: TAGS,
    params: z.strictObject({
        flowRunId: z.uuid(),
        blockId: z.string().describe('The block id within the flow definition.'),
    }),
    response: GetFlowRunBlockResponseSchema,
};
//# sourceMappingURL=routes.js.map